import React from 'react';
import {connect} from 'react-redux'
import {LockOutlined, MailOutlined} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Col, Modal, Row, Select } from "antd";
import 'antd/lib/modal/style/css';
import {Field, reduxForm} from "redux-form";
import getAllRoles from "../../actions/getAllRoles";
import {CreatePasswordField, CreateSelectField, CreateTextField} from "../../helpers/InputCreator";
import {email, required} from "../../helpers/validations";
import {userNormalizer} from "../../helpers/normalizers";
import languages from "../../language/languages";
import {SHOW_MSG} from "../../types";


class AdminUsersModal extends React.Component {

    state = {formFile: []};

    componentDidMount() {
        this.props.getAllRoles();
        let entry=this.props.entry;
        let roleId="1";
        let userName="";
        if(entry)
        {
            roleId = entry.userRole + "";
            userName=entry.userName;
        }
        this.props.initialize({'userRole': roleId,'userName':userName});
    }

    renderRoles = () => {
        if (!this.props.roles || this.props.roles.length <= 0)
            return '';
        return this.props.roles.map((role) => <Select.Option key={role.id}>{role.description}</Select.Option>);
    };


    renderFields() {
        return (
            <Row>
                <Col md={24}>
                    <Field label={languages[this.props.language].role_column}
                           name="userRole"
                           component={CreateSelectField}
                           placeholder={languages[this.props.language].role_column}
                           validate={[required]}
                           hasFeedback>
                        {this.renderRoles()}
                    </Field>
                </Col>
                <Col md={24}>
                    <Field placeholder={languages[this.props.language].user_column}
                           label={languages[this.props.language].user_column}
                           name="userName"
                           size={'large'}
                           component={CreateTextField}
                           prefix={<MailOutlined style={{color: 'rgba(0,0,0,.25)'}} />}
                           validate={[email]}
                           autocomplete={'new-password'}
                           disabled={this.props.update}
                           normalize={userNormalizer}
                           hasFeedback/>
                </Col>
                {this.props.update?'':<Col md={24}>
                    <Field label={languages[this.props.language].newPass}
                           name="password"
                           size={'large'}
                           component={CreatePasswordField}
                           prefix={<LockOutlined className={'icon-font'} />}
                           placeholder={languages[this.props.language].newPass}
                           autocomplete={'new-password'}
                           validate={[required]}
                           hasFeedback/>
                </Col>}
                {this.props.update?'':<Col md={24}>
                    <Field label={languages[this.props.language].confirmNewPass}
                           name="password_confirmation"
                           component={CreatePasswordField}
                           size={'large'}
                           autocomplete={'new-password'}
                           prefix={<LockOutlined className={'icon-font'} />}
                           placeholder={languages[this.props.language].confirmNewPass}
                           validate={[required]}
                           hasFeedback/>
                </Col>}
            </Row>
        );
    }

    validate = (form) => {
        if (form.password !== form.password_confirmation)
            this.props.dispatch({
                type: SHOW_MSG,
                payload: {message: languages[this.props.language].dontMatch, type: 'error'}
            });
        else
            this.props.onSubmit(form);
    }

    render() {
        return (
            <Modal centered
                visible={this.props.modalType !== null} width={400} {...this.props.modalProps}>
                <Form onSubmit={this.props.handleSubmit(this.validate)}>
                    {this.renderFields()}
                    <Row>
                        <Button htmlType={'submit'} type={'primary'}>{this.props.btn}</Button>
                    </Row>
                </Form>
            </Modal>
        )
    }

}

function mapStateToProps(state) {
    return {
        language: state.auth.language,
        roles: state.users.roles
    }
}

export default connect(mapStateToProps, {getAllRoles})(reduxForm({form: 'admin_users_form'})(AdminUsersModal));
